import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Container, Carousel, Grid, Button } from 'components/base';
import { CloudinaryPicture } from 'components/rich';

import CarouselBgLeft from '../../../public/static/img/carousel-item-bg-left.svg';
import CarouselBgRight from '../../../public/static/img/carousel-item-bg-right.svg';

export const THEMES = [
  {
    backgroundColor: '#FFECEB',
    buttonType: 'primary',
    color: '#EECFCB',
    opacity: 1,
  },
  {
    backgroundColor: '#BAE4E1',
    buttonType: 'primary',
    color: '#008A7E',
    opacity: 0.4,
  },
  {
    backgroundColor: '#FFF6DF',
    buttonType: 'primary',
    color: '#F69054',
    opacity: 0.4,
  },
  {
    backgroundColor: '#F4F5FB',
    buttonType: 'primary',
    color: '#27326C',
    opacity: 0.2,
  },
];

const HomeCarousel = forwardRef((props, ref) => {
  const totalSlides = React.Children.count(props.children);

  const enabled = totalSlides > 1;

  return (
    <Carousel
      ref={ref}
      className="carousel-hero"
      totalSlides={totalSlides}
      isPlaying={enabled}
      infinite={enabled}
      touchEnabled={enabled}
      dragEnabled={enabled}
    >
      <Carousel.Slider classNameAnimation="homeCarouselAnimation">{props.children}</Carousel.Slider>
      {enabled && <Carousel.DotGroup />}
    </Carousel>
  );
});

HomeCarousel.propTypes = {
  children: PropTypes.node,
};

const CarouselItem = forwardRef((props, ref) => {
  const theme = THEMES[props.index % THEMES.length];

  return (
    <Carousel.Slide
      ref={ref}
      index={props.index}
      className={props.className}
      style={{ backgroundColor: theme.backgroundColor }}
    >
      <Container>
        <Grid.Row>
          <Grid.Col xs={12} md={6} className="carousel-item-background">
            <div className="carousel-item-data">
              {props.children}
              <Button asLink href={props.href} type={theme.buttonType} size="lg">
                {props.buttonLabel}
              </Button>
            </div>
            <span className="carousel-item-bg-left" style={{ color: theme.color }}>
              <CarouselBgLeft />
            </span>
            <span className="carousel-item-bg-right" style={{ color: theme.color }}>
              <CarouselBgRight />
            </span>
          </Grid.Col>
          <Grid.Col xs={12} md={6} className="px-2 px-sm-0">
            <CloudinaryPicture imageKey={props.image} />
          </Grid.Col>
        </Grid.Row>
      </Container>
    </Carousel.Slide>
  );
});

CarouselItem.propTypes = {
  index: PropTypes.number,
  image: PropTypes.string,
  href: PropTypes.string,
  buttonLabel: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

CarouselItem.defaultProps = {
  index: 0,
  buttonLabel: 'Learn More',
};

HomeCarousel.Item = CarouselItem;

export default HomeCarousel;
